module.exports = __webpack_public_path__ + "static/media/MHRP77N0010.f8d10db7.svg";